import Vue from "vue";
import Vuex from "vuex";
import { isArrayEmpty, isStrEmpty, generateCombinations } from "@/utils/utils";
import { getUserInfo } from "@/services/axios";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        userInfo: !isStrEmpty(getUserInfo()) ? JSON.parse(getUserInfo()) : null,
        tokenV3: localStorage.getItem("access_tokenv3"),
        cart: [],
        cartRender: [],
        quantity: 0,
        transactPariLotto: [],
        transact: [],
        enabled_game_slugs: "",
        isShowSports: true,
        isOnlyPaument: true,
        isShow645: true,
        isShow590: true,
        isShowVoucher: true,
        isLoadingAddCart: false,
        totalCart: 0,
        dataGamesPari: [],
        stepCart: 1,
        versionApp: "1.1.1",
    },
    getters: {},
    mutations: {
        SET_USER_INFO(state, data) {
            state.userInfo = data;
        },

        REMOVE_USER_INFO(state) {
            state.userInfo = null;
            localStorage.removeItem("user_info");
        },

        SET_TOKEN_V3(state, data) {
            state.tokenV3 = data;
        },

        SET_DATA_CART(state, data) {
            state.cart = data.cart;
            state.cartRender = data.cartRender;
            state.quantity = data.quantity;
            state.transact = data.transact;
            state.totalCart = data.totalCart;
            state.transactPariLotto = data.transactPariLotto;
            localStorage.setItem(
                "transactPariLotto",
                JSON.stringify(data.transactPariLotto)
            );

            localStorage.setItem(
                "cartRender",
                JSON.stringify(data.cartRender ? data.cartRender : [])
            );
            localStorage.setItem("cart", JSON.stringify(data.cart));
            localStorage.setItem("quantity", data.quantity);
            localStorage.setItem("transact", JSON.stringify(data.transact));
            localStorage.setItem("totalCart", JSON.stringify(data.totalCart));
            state.isLoadingAddCart = false;
        },
        SET_DATA_CART_SWITCH(state, data) {
            state.totalCart = data.totalCart;
            state.cartRender = data.cartRender;
            state.stepCart = data.step;
            localStorage.setItem("totalCart", JSON.stringify(data.totalCart));
            localStorage.setItem("cartRender", JSON.stringify(data.cartRender));
            localStorage.setItem("stepCart", JSON.stringify(data.step));
        },

        SET_CONFIG(state, payload) {
            state.isShow590 = payload.isShow590;
            state.isShow645 = payload.isShow645;
            state.isShowSports = payload.isShowSports;
        },
    },
    actions: {
        handleUserInfo({ commit, state }, data) {
            commit("SET_USER_INFO", data);
        },

        removeUserInfo({ commit }) {
            commit("REMOVE_USER_INFO");
        },

        setTokenV3({ commit, state }, data) {
            commit("SET_TOKEN_V3", data);
        },

        onSwitchBetslip({ commit, state }, payload) {
            const { step } = payload;
            const cart: any = state.cart;

            let cartRender = cart.filter((x) =>
                step === 1 ? !x.isPariMutuelLotto : x.isPariMutuelLotto
            );
            let totalCart = cartRender.reduce((a, b) => a + b.price, 0);
            const param = {
                totalCart,
                cartRender,
                step,
            };

            commit("SET_DATA_CART_SWITCH", param);
        },

        onAddToCart({ commit, state }, payload) {
            const cart: any = state.cart;
            let cartRender: any = [];
            const transact: any = state.transact;
            const transactPariLotto: any = state.transactPariLotto;
            let quantity: number = state.quantity;
            let totalCart: number = 0;
            let title = `${payload.title}`;
            let game = `${payload.game}`;
            let quantityBets = 1;

            if (!payload.isPariMutuelLotto) {
                title += ` ${payload.gameNumber}`;
                game += `${payload.gameNumber}`;
            }

            payload.event_id.map((eventId, i) => {
                let item = {
                    id: new Date()
                        .getTime()
                        .toString(36)
                        .concat(
                            performance.now().toString(),
                            Math.random().toString()
                        )
                        .replace(/\./g, ""),
                    parentId: payload.id,
                    eventId,
                    eventDate: payload.eventInfo[i].date,
                    eventName: payload.eventInfo[i].name,
                    selection: [payload.selection],
                    title,
                    price: payload.wager,
                    bets: 0,
                    isPariMutuelLotto: payload?.isPariMutuelLotto,
                };

                if (
                    payload.isPariMutuelLotto &&
                    payload.selection.length > payload.numberQp
                ) {
                    quantityBets = generateCombinations(
                        Number(payload.selection.length),
                        Number(payload.numberQp)
                    );
                    item["price"] = payload.wager * quantityBets;
                    item["bets"] = quantityBets;
                }

                cart.push(item);
            });

            let item = {
                id: payload.id,
                selection: [payload.selection],
                draws: payload.draws,
                event_id: payload.event_id,
                wager: payload.wager,
                game,
            };

            if (payload.isPariMutuelLotto) {
                transactPariLotto.push(item);
            } else {
                transact.push(item);
            }
            cartRender = cart.filter((x) =>
                state.stepCart === 1
                    ? !x.isPariMutuelLotto
                    : x.isPariMutuelLotto
            );
            totalCart = cartRender.reduce((a, b) => a + b.price, 0);
            quantity = cart.length;

            const param = {
                quantity,
                transact,
                cart,
                totalCart,
                transactPariLotto,
                cartRender,
            };

            commit("SET_DATA_CART", param);
        },
        onRemoveItemCart({ commit, state }, payload) {
            const cart: any = state.cart;
            let cartRender: any = [];
            let transact: any = state.transact;
            let transactPariLotto: any = state.transactPariLotto;
            let quantity: number = state.quantity;
            let totalCart: number = state.totalCart;
            const element = payload.item;

            let transactClone = element.isPariMutuelLotto
                ? transactPariLotto
                : transact;

            const index = transactClone.findIndex(
                (x) => x.id === element.parentId
            );

            if (index !== -1) {
                transactClone[index].event_id = transactClone[
                    index
                ].event_id.filter((x) => x !== element.eventId);
            }

            if (isArrayEmpty(transactClone[index]?.event_id)) {
                transactClone.splice(index, 1);
            }

            const indexCart = cart.findIndex((x) => x.id === element.id);

            cart.splice(indexCart, 1);

            let isPariMutuelLotto = state.stepCart === 1;
            cartRender = isPariMutuelLotto
                ? cart.filter((x) => !x.isPariMutuelLotto)
                : cart.filter((x) => x.isPariMutuelLotto);
            totalCart = cartRender.reduce((a, b) => a + b.price, 0);
            quantity = cart.length;
            let param = {
                quantity,
                transact,
                cart,
                totalCart,
                transactPariLotto,
                cartRender,
            };

            if (element.isPariMutuelLotto) {
                param["transactPariLotto"] = transactClone;
            } else {
                param["transact"] = transactClone;
            }

            commit("SET_DATA_CART", param);
        },

        onClearCart({ state, commit }) {
            let cart: any = state.cart;
            let isPariMutuelLotto = state.stepCart === 1;

            cart = isPariMutuelLotto
                ? cart.filter((x) => x.isPariMutuelLotto)
                : cart.filter((x) => !x.isPariMutuelLotto);
            let totalCart = cart.reduce((a, b) => a + b.price, 0);
            let quantity = cart.length;

            let param = {
                quantity,
                transact: isPariMutuelLotto ? [] : state.transact,
                cart: cart,
                totalCart,
                transactPariLotto: !isPariMutuelLotto
                    ? []
                    : state.transactPariLotto,
                cartRender: [],
            };
            commit("SET_DATA_CART", param);
        },

        handleSaveConfig({ commit }, payload) {
            commit("SET_CONFIG", payload);
        },
    },

    plugins: [createPersistedState()],
});
